// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"985faf08","244":"bd68f205"}[chunkId] + ".chunk.js";
};